import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Table } from "react-bootstrap";
import { holdNotesFields } from "./holdNotesField";
import moment from "moment";

export default class HoldNotesArchievedModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      res: this.props.res,
    };
    this.onModalHide = this.onModalHide.bind(this);
  }

  onModalHide() {
    let { hide } = this.props;
    this.setState(() => {
      hide && hide(null, false, "archivedHoldNotes");
    });
  }

  render() {
    let { show, res, holdNotesData } = this.props;

    // New index uses Archived (boolean) instead of IsArchived ("0"/"1")
    const archivedNotes =
      holdNotesData &&
      holdNotesData.filter((data) => data._source.Archived === true);

    return (
      <Modal
        show={show}
        onHide={() => this.onModalHide()}
        animation={false}
        // dialogClassName="show-more_modal-dailog"
        className="hold_notes_modal"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Hold Notes:
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="hold_notes_container">
            {archivedNotes && archivedNotes.length !== 0 && (
              <Table>
                <thead>
                  <tr>
                    {holdNotesFields &&
                      holdNotesFields.map((fieldData) => {
                        return <th key={fieldData.field}>{fieldData.label}</th>;
                      })}
                  </tr>
                </thead>
                <tbody>
                  {archivedNotes
                    .sort(
                      (a, b) =>
                        parseInt(
                          (b._source.HoldDate || "").replace(/-/g, "").slice(0, 9)
                        ) -
                        parseInt(
                          (a._source.HoldDate || "").replace(/-/g, "").slice(0, 9)
                        )
                    )
                    .map((data, rowIdx) => (
                      <tr key={rowIdx}>
                        {holdNotesFields &&
                          holdNotesFields.map((fieldData) => {
                            // Date fields — format for display
                            if (fieldData.field.includes("Date")) {
                              return (
                                <td key={fieldData.field}>
                                  {data._source[fieldData.field]
                                    ? moment(
                                        new Date(
                                          `${data._source[fieldData.field]}`
                                        )
                                      ).format("MM/DD/YYYY")
                                    : ""}
                                </td>
                              );
                            }
                            // IsSold is now a boolean in the new index
                            if (fieldData.field === "IsSold") {
                              return (
                                <td key={fieldData.field}>
                                  {data._source[fieldData.field] ? "Yes" : "No"}
                                </td>
                              );
                            }
                            // EmployeeName_2 with fallback to EmployeeName
                            if (fieldData.field === "EmployeeName_2") {
                              return (
                                <td key={fieldData.field}>
                                  {data._source.EmployeeName_2 ||
                                    data._source.EmployeeName ||
                                    ""}
                                </td>
                              );
                            }
                            return (
                              <td key={fieldData.field}>
                                {data._source[fieldData.field]}
                              </td>
                            );
                          })}
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
